module.exports = __webpack_public_path__ + "img/active.be87b436.png";